import { Component, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Estimation } from '../../models/estimacion.model';
import { EstimacionService } from '../../services/estimacion.service';
import { GlobalModalService } from '../../shared/global-modal/global-modal.service';
import { LoggerService } from '../../services/logger.service';
import { concatMap, finalize } from 'rxjs/operators';

@Component({
  selector: 'app-modal-estimation-wizard',
  templateUrl: './modal-estimation-wizard.component.html',
  styleUrls: ['./modal-estimation-wizard.component.scss']
})
export class ModalEstimationWizardComponent {
  newEstimation: Estimation = new Estimation();
  currentStep = 1;
  @Output() close = new EventEmitter<void>();
  
  loading: boolean = false;
  streamingText: string = '';

  constructor(
    private http: HttpClient, 
    private router: Router, 
    private estimacionService: EstimacionService, 
    private globalModalService: GlobalModalService, 
    private logger: LoggerService,
    private cdRef: ChangeDetectorRef 
  ) {}

  nextStep() {
    if (this.currentStep < 3) this.currentStep++;
  }

  previousStep() {
    if (this.currentStep > 1) this.currentStep--;
  }

  closeModal() {
    this.close.emit();
  }

  calculateEstimation() {
    this.loading = true;
    this.streamingText = ''; 

    this.estimacionService.streamRAGPT(this.newEstimation, (chunkText: string) => {
      this.streamingText = chunkText;
      this.cdRef.detectChanges();
    }).then((parsedResults: any) => {
      
      if (parsedResults && parsedResults.requirements) {
        this.newEstimation.requirements = parsedResults.requirements;
      } else {
        this.logger.warn('No requirements found in estimationResults');
      }

      // ===== Bloques v3: copiar metadata y rollup al modelo de la estimación =====
      // Sin esto, el wizard envía solo requirements al backend y se pierden
      // los datos enriquecidos del modelo (warnings, calibration_summary,
      // self_check, prompt_version, rollup con P50/contingencia, etc.).
      if (parsedResults && parsedResults.metadata) {
        this.newEstimation.metadata = parsedResults.metadata;
      }
      if (parsedResults && parsedResults.metadata_original) {
        this.newEstimation.metadata_original = parsedResults.metadata_original;
      }
      if (parsedResults && parsedResults.rollup) {
        this.newEstimation.rollup = parsedResults.rollup;
      }

      this.estimacionService.saveEstimation(this.newEstimation).pipe(
        concatMap((savedData: any) => {
          return this.estimacionService.getEstimationById(savedData.id.toString());
        })
      )
      .pipe(finalize(() => { this.loading = false; }))
      .subscribe(
        (fetchedEstimation: any) => {
          this.newEstimation = fetchedEstimation;
          // Mantenemos la estimación en sesión por si el usuario navega a la pestaña de detalles
          sessionStorage.setItem('selectedEstimation', JSON.stringify(this.newEstimation));

          this.logger.log('this.newEstimation: ', this.newEstimation);

          // NUEVO: Guardamos el proyecto asociado en sesión para que lo lea la pantalla de proyecto
          if (this.newEstimation.project) {
            sessionStorage.setItem('selectedProject', JSON.stringify(this.newEstimation.project));
          }

          // CAMBIO: Redirigimos a la pantalla del proyecto
          this.router.navigate(['/app/proyecto']).then(() => {
            this.closeModal(); 
          });

          // this.router.navigate(['/app/estimaciones']).then(() => {
          //   this.loading = false;
          //   this.closeModal(); 
          // });
        },
        (error: any) => {
          this.logger.error('Error during estimation process:', error);
        }
      );

    }).catch((err: any) => {
      this.loading = false;
      this.logger.error('Error in streaming:', err);
      this.globalModalService.showError('Error de Generación', err.message || 'Error conectando con IA');
    });
  }

  loadEstimation(id: number): void {
    this.logger.info("ModalEstimationWizardComponent.loadEstimation");
    this.estimacionService.getEstimationById(id.toString()).subscribe(
      (data: any) => {
        this.newEstimation = data;
      },
      (error: any) => { this.logger.error('Error loading estimation: ', error); }
    );
  }
}